export default __webpack_public_path__ + "static/media/arrow-down-gray.50258532.svg";